import React, { Fragment, useState } from 'react'
import { appNumber } from 'utils'
import './AppFormItem.less'

export interface AppInputProps {
	dataType?: 'string' | 'number'
	readonly?: boolean
	value?: string
	format?: string
	tips?: string
	error?: string
	prefix?: string
	placeholder?: string
	forbidChars?: string
	unit?: string
	onChange?: (value: string | number, text: string) => void
}

export const AppInput = (props: AppInputProps) => {
	const [focus, setFocus] = useState(false)

	const getFormatValue = (value?: string) => {
		let dataType = props.dataType || 'string'
		if (dataType === 'string') return value || ''
		return appNumber.format(value, props.format)
	}

	const onChange = () => {
		let text =
			props.dataType === 'number'
				? appNumber.format(refInput.current.value, props.format)
				: refInput.current.value
		let value = props.dataType === 'number' ? appNumber.returnValue(text) : text
		refInput.current.value = text.toString()
		props.onChange && props.onChange(value, text)
		setFocus(false)
	}

	const refInput = React.createRef<HTMLInputElement>()
	return (
		<Fragment>
			<span className="app-form-item-input" style={{ borderWidth: '0px', width: '100%' }}>
				<div
					className={`mc-spinner ${focus ? 'mc-spinner-focus' : ''} ${
						props.error && props.error !== '' ? 'mc-spinner-error' : ''
					}`}
				>
					{props.prefix && props.prefix !== '' ? (
						<div className="input-group-prepend" style={{ borderRight: '0px', height: 28 }}>
							<span>{props.prefix}</span>
						</div>
					) : (
						''
					)}
					<div className="input input-group input-group-append">
						<div style={{ display: 'inline-table', width: '100%' }}>
							<div className="input-inner-warp">
								<input
									ref={refInput}
									title={getFormatValue(props.value)}
									// type={props.dataType}
									className="input-inner"
									style={{
										textAlign: props.dataType && props.dataType === 'number' ? 'right' : 'left',
									}}
									placeholder={props.placeholder || ''}
									defaultValue={getFormatValue(props.value)}
									onBlur={onChange}
									readOnly={props.readonly || false}
									onFocus={e => setFocus(true)}
								/>
							</div>
							{props.unit && props.unit !== '' ? (
								<div className="input-group-append-unit">
									<span className="mc-spinner-unit">{props.unit}</span>
								</div>
							) : (
								''
							)}
						</div>
					</div>
				</div>
				{props.tips && props.tips !== '' ? <span className="mc-spinner-tips">{props.tips}</span> : ''}
				{props.error && props.error !== '' ? <span className="mc-spinner-error">{props.error}</span> : ''}
			</span>
		</Fragment>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppInput.tsx